import { Observable } from 'rxjs/Rx'

import { Resource } from './../../models'
import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../../model-repository/model-repository'


export class ResourceService extends ModelRepositoryAdapter<Resource> {

  constructor(_modelRepository: ModelRepository) {
    super(_modelRepository, Resource)
    this.initialize()
  }

  /**
   * @deprecated Use findModelById instead
   */
  public getResource(resourceId: string): Observable<Resource> {
    return this.findModelById(resourceId)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/resource/resource.service.ts